<!--
 * @Author: shaozongyao
 * @Date: 2021-12-17 09:55:03
 * @LastEditTime: 2021-12-17 10:02:58
 * @LastEditors: shaozongyao
-->
<!--
 * @Author: shaozongyao
 * @Date: 2021-11-29 16:04:39
 * @LastEditTime: 2021-12-10 08:52:19
 * @LastEditors: your name
-->
<template>
  <div class="wrapper">
    <div class="header">
      <img :src="$oss(37)" style="width: 100%;" alt="" />
      <img :src="$oss(48)" class="logo" alt="" />
    </div>

    <div class="content padding-lr-14">
      <div class="card padding-tb-14 padding-lr-24">
        <img :src="$oss(47)" style="width: 100%;" alt="" />
        <template v-if="!success">
          <input
            v-model="phone"
            :maxlength="11"
            class="phone-box"
            type="number"
            placeholder="输入手机号"
            @input="onPhoneInput"
          />
          <div class="flex code-box" style="width: 100%;">
            <input
              v-model="code"
              class="code-input flex-1"
              type="number"
              placeholder="输入验证码"
              @input="onCodeInput"
            />
            <div
              @click="getCode"
              class="text-center"
              style="width: 100px;"
              :class="[disableCode ? 'text-grey1' : 'text-black']"
            >
              {{ codeText }}
            </div>
          </div>
          <div class="margin-top-8 flex" @click="agree = !agree">
            <img
              :src="$oss(agree ? 41 : 42)"
              class="margin-top-2"
              style="width: 12px; height: 12px;"
              alt=""
            />
            <div class="text-12 text-grey1 margin-left-4">
              我已阅读并同意滇约易游的<span
                class="agreement"
                @click.stop="jumpToagrrement(1)"
                >《注册协议》</span
              >、<span class="agreement" @click.stop="jumpToagrrement(1)"
                >《隐私协议》</span
              >
            </div>
          </div>

          <div
            class="margin-top-14 btn"
            :class="[disabled ? 'disabled' : 'active']"
            @click="joinActivity"
          >
            立即领取
          </div>
        </template>

        <div v-else class="margin-tb-20 flex flex-y align-center text-center text-18 text-primary">
          <div class="margin-bottom-14">成功参与活动，快去使用吧</div>
          <img src="https://dyyy-static.oss-cn-shenzhen.aliyuncs.com/sfc-assets/h5/43.jpg" style="width: 120px; height: 120px;" alt="" />
        </div>
      </div>

      <div class="margin-top-10 card padding-14">
        <div class="title">活动规则</div>
        <ul>
          <li class="rule-item" v-for="item in rules" :key="item">
            {{ item }}
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { getCode, joinActivity } from 'api/insurance'
export default {
  name: 'RideSchool',
  data () {
    return {
      phone: '',
      code: '',
      disableCode: true,
      agree: false,
      seconds: 60,
      codeText: '获取验证码',
      rules: [
        '1、活动开始时间： 2021年12月1日',
        '2、用户可领取30元乘车金，下单即可使用',
        '3、此活动福利仅限云南地区使用',
        '4、如因不可抗力（包括但不限于重大自然灾害事件、政府主管部门指令停止举办或遭受严重网络攻击、系统故障等）导致活动无法进行，平台可依据相关法律法规的规定暂停或终止本次活动',
        '5、较低版本的滇约易游小程序可能不支持活动部分功能，请更新至最新版本',
        '6、每个用户仅限使用一个账号参与活动，同一身份信息、同一手机号、同一设备ID、同一支付账号均被认为是同一用户。每个用户限领一次',
        '6、在法律允许的范围内，如发现参与活动用户有作弊违规等不正当行为，平台将取消该用户参与活动的资格并冻结已发放的奖励。对于情况较严重者，平台有权取消相关用户在平台服 务的资格。不正当行为包括但不限于：使用非法程序或工具分享、下载、安装、注册、登录多个账号套取平台奖励，非正常下单、接单、刷单、信用卡套现等不正常行为。'
      ],
      success: false
    }
  },
  computed: {
    disabled () {
      const validPhone = /^(?:(?:\+|00)86)?1[3-9]\d{9}$/.test(this.phone)
      const validCode = /^[0-9]{6}$/.test(this.code)
      return !(validPhone && validCode)
    }
  },
  methods: {
    jumpToagrrement (status) {
      let id = 0
      switch (status) {
        case 1:
          id = 21288000000005
          break
        case 2:
          id = 21109000000010
          break
      }
      this.$router.push(`/agreement/detail/${id}`)
    },
    validPhone () {
      return /^(?:(?:\+|00)86)?1[3-9]\d{9}$/.test(this.phone)
    },
    validCode () {
      return /^[0-9]{6}$/.test(this.code)
    },
    getCode () {
      if (this.disableCode) return
      getCode({
        mobile: this.phone,
        activityId: 213330000004
      }).then(res => {
        this.$toast.success('验证码已发送')
        this.disableCode = true
        this.codeText = `${this.seconds}s`
        const timer = setInterval(() => {
          this.seconds--
          this.codeText = `${this.seconds}s`
          if (this.seconds <= 0) {
            console.log('end')
            clearInterval(timer)
            this.seconds = 60
            this.codeText = '获取验证码'
            this.disableCode = !this.validPhone()
          }
        }, 1000)
      })
    },
    joinActivity () {
      if (this.disabled) return
      if (!this.agree) {
        this.$toast('请先勾选协议')
        return
      }
      joinActivity({
        mobile: this.phone,
        activityId: 213330000004,
        verifyCode: this.code
      }).then(res => {
        this.$toast.success('参与成功')
        this.success = true
      })
    },
    onPhoneInput (e) {
      if (this.phone.length > 11) {
        this.phone = this.phone.slice(0, 11)
      }
      if (!this.validPhone()) {
        this.disableCode = true
        return
      }
      this.disableCode = false
    },
    onCodeInput () {
      if (this.code.length > 6) {
        this.code = this.code.slice(0, 6)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.wrapper {
  background-color: rgba(254, 183, 110, 1);
  min-height: 100vh;
  padding-bottom: 33px;
}
.header {
  position: relative;
}
.logo {
  position: absolute;
  left: 50%;
  top: 0;
  transform: translateX(-50%);
  width: 106px;
  height: 32.5px;
}

.content {
  position: relative;
  margin-top: -42%;
  z-index: 1;
}

.card {
  background-color: #fff;
  border-radius: 7px;
}

.phone-box {
  display: block;
  background-color: $body;
  width: 100%;
  height: 46px;
  border: none;
  font-size: 16px;
  &::placeholder {
    color: $grey2;
    font-size: 16px;
  }
  padding: 0 14px;
  border-radius: 6px;
  margin-top: 13px;
}

.code-box {
  margin-top: 13px;
  background-color: $body;
  height: 46px;
  font-size: 16px;
  border-radius: 7px;
  & > .code-input {
    width: 100%;
    height: 46px;
    outline: none;
    border: none;
    padding-left: 14px;
    background-color: transparent;
    display: block;
    &::placeholder {
      color: $grey2;
      font-size: 16px;
    }
  }
  & > div {
    padding: 0 14px;
    height: 46px;
    line-height: 46px;
    font-size: 14px;
    position: relative;
    &::before {
      content: "";
      display: block;
      position: absolute;
      left: 0;
      top: 50%;
      width: 1px;
      height: 60%;
      background-color: $grey3;
      transform: translateY(-50%) scaleX(0.5);
    }
  }
}

.btn {
  height: 45px;
  border-radius: 22.5px;
  text-align: center;
  line-height: 45px;
}

.disabled {
  background: rgba(238, 238, 238, 1);
  color: $grey1;
  box-shadow: 0 0 12px 0 #eee;
}
.active {
  background-color: $primary;
  color: #fff;
  box-shadow: 0 0 12px 0 $primary;
}
.title {
  font-size: 16px;
  color: rgba(254, 183, 110, 1);
}

.rule-item {
  color: $grey;
  margin-top: 15px;
}

.agreement {
  color: $black;
  font-weight: bold;
}
</style>
